import React from 'react';
import { ISplash } from '@montana/models/generated/cms.interface';

export const Splash = (props: ISplash) => {
    const { displayName, textColor, backgroundColor } = props;

    const styles: React.CSSProperties = {
        backgroundColor: backgroundColor,
        color: textColor
    };

    return displayName ?
        <div className="splash" style={styles}>{displayName}</div>
        :
        <></>
    ;
}
